export const USER_SIGN_IN = "V2_USER_SIGN_IN";
export const USER_SIGN_OUT = "V2_USER_SIGN_OUT";
export const USER_PROFILE_UPDATE = 'V2_USER_PROFILE_UPDATE';
export const USER_PROFILE_PREFERENCE_UPDATE = 'V2_USER_PROFILE_PREFERENCE_UPDATE';